import { render, staticRenderFns } from "./VuetableColGroup.vue?vue&type=template&id=260f33c4"
import script from "./VuetableColGroup.vue?vue&type=script&lang=js"
export * from "./VuetableColGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports